import { Point3D } from "../entity/Point3D.js";
import { Vector } from "../entity/Vector.js";
import { Obj } from "../entity/object/obj/Obj.js";
import { Point2D } from "../entity/Point2D.js";
var MathUtil;
((MathUtil2) => {
  MathUtil2.getMinByObjectArray = (objectArray, varName) => {
    let min2;
    if (varName && objectArray && objectArray.length > 0) {
      min2 = objectArray[0][varName];
      for (let i = 1; i < objectArray.length; i++) {
        min2 = Math.min(min2, objectArray[i][varName]);
      }
    }
    return min2;
  };
  MathUtil2.hypot = (...data) => {
    return Math.hypot(...data);
  };
  MathUtil2.pythagorean = (a, b) => {
    return Math.sqrt(a * a + b * b);
  };
  MathUtil2.getMaxByObjectArray = (objectArray, varName) => {
    let max2;
    if (varName && objectArray && objectArray.length > 0) {
      max2 = objectArray[0][varName];
      for (let i = 1; i < objectArray.length; i++) {
        max2 = Math.max(max2, objectArray[i][varName]);
      }
    }
    return max2;
  };
  MathUtil2.sum = (array) => {
    return array.reduce((acc, curr) => acc + curr, 0);
  };
  MathUtil2.avg = (array) => {
    return array.length > 0 ? MathUtil2.sum(array) / array.length : 0;
  };
  MathUtil2.minMax = (data, minMax2) => {
    return Math.min(Math.max(data, minMax2.min), minMax2.max);
  };
  MathUtil2.max = (array) => {
    return array.length > 0 ? Math.max(...array) : void 0;
  };
  MathUtil2.min = (array) => {
    return array.length > 0 ? Math.min(...array) : void 0;
  };
  MathUtil2.getSumByObjectArray = (objectArray, varName) => {
    let sum2 = 0;
    if (varName && objectArray && objectArray.length > 0) {
      for (let i = 0; i < objectArray.length; i++) {
        sum2 += objectArray[i][varName];
      }
    }
    return sum2;
  };
  MathUtil2.radians = (data, { type = "degreeAngle" }) => {
    if (type === "ratio") {
      return data * 2 * Math.PI;
    } else if (type === "percent") {
      return data / 100 * 2 * Math.PI;
    } else {
      return data / 180 * Math.PI;
    }
  };
  MathUtil2.degrees = (data, { type = "degreeAngle" }) => {
    if (type === "ratio") {
      return data * 360;
    } else if (type === "percent") {
      return data / 100 * 360;
    } else {
      return data * 180 / Math.PI;
    }
  };
  MathUtil2.ratio = (numerator, denominator, multiplier = 1) => {
    return multiplier * (denominator / numerator);
  };
  MathUtil2.getBetweenLength = (start, end) => {
    return end - start;
  };
  MathUtil2.getPercentByTotal = (tot, data) => {
    return data / tot * 100;
  };
  MathUtil2.getRatioByTotal = (tot, data) => {
    return data / tot;
  };
  MathUtil2.getValueByTotalInPercent = (tot, wantPercent) => {
    return tot * wantPercent / 100;
  };
  MathUtil2.getValueByTotalInRatio = (tot, ratio2) => {
    return tot * ratio2;
  };
  MathUtil2.getValuePercentUp = (tot, wantPercent) => {
    return tot * (1 + wantPercent / 100);
  };
  MathUtil2.getValueRatioUp = (tot, ratio2) => {
    return tot * (1 + ratio2);
  };
  MathUtil2.getValuePercentDown = (tot, wantPercent) => {
    return tot * (1 - wantPercent / 100);
  };
  MathUtil2.getValueRatioDown = (tot, ratio2) => {
    return tot * (1 - ratio2);
  };
  MathUtil2.beziers = (points, frame) => {
    const datas = new Array(frame).fill(void 0);
    for (let i = 0; i < datas.length; i++) {
      datas[i] = MathUtil2.bezier(points, frame, i);
    }
    return datas;
  };
  MathUtil2.bezier = (points, frame, idx) => {
    if (points && points.length > 0) {
      const pv = points.map((it) => new Vector(it.x, it.y, it.z));
      const steps = [];
      pv.reduce((a, b) => {
        const step = a.toSub(b).div(frame).mult(idx + 1);
        steps.push(a.toSub(step));
        return b;
      });
      if (steps.length <= 1) {
        return steps[0];
      }
      return MathUtil2.bezier(steps.map((it) => new Point3D(it)), frame, idx);
    } else {
      return new Vector();
    }
  };
  function cubicBezier(position, frameConfig, bezierConfig) {
    if (position.start instanceof Obj && position.end instanceof Obj) {
      const x = MathUtil2.cubicBezier({ start: position.start.x, end: position.end.x }, frameConfig, bezierConfig);
      const y = MathUtil2.cubicBezier({ start: position.start.y, end: position.end.y }, frameConfig, bezierConfig);
      const z = MathUtil2.cubicBezier({ start: position.start.z, end: position.end.z }, frameConfig, bezierConfig);
      const v = MathUtil2.cubicBezier({ start: position.start.volume, end: position.end.volume }, frameConfig, bezierConfig);
      const m = MathUtil2.cubicBezier({ start: position.start.mass, end: position.end.mass }, frameConfig, bezierConfig);
      const e = MathUtil2.cubicBezier({ start: position.start.e, end: position.end.e }, frameConfig, bezierConfig);
      const r = MathUtil2.cubicBezier({ start: position.start.rotate, end: position.end.rotate }, frameConfig, bezierConfig);
      const w = MathUtil2.cubicBezier({ start: position.start.width, end: position.end.width }, frameConfig, bezierConfig);
      const h = MathUtil2.cubicBezier({ start: position.start.height, end: position.end.height }, frameConfig, bezierConfig);
      const t0 = MathUtil2.cubicBezier({ start: position.start.transform[0], end: position.end.transform[0] }, frameConfig, bezierConfig);
      const t1 = MathUtil2.cubicBezier({ start: position.start.transform[1], end: position.end.transform[1] }, frameConfig, bezierConfig);
      const t2 = MathUtil2.cubicBezier({ start: position.start.transform[2], end: position.end.transform[2] }, frameConfig, bezierConfig);
      const t3 = MathUtil2.cubicBezier({ start: position.start.transform[3], end: position.end.transform[3] }, frameConfig, bezierConfig);
      const t4 = MathUtil2.cubicBezier({ start: position.start.transform[4], end: position.end.transform[4] }, frameConfig, bezierConfig);
      const t5 = MathUtil2.cubicBezier({ start: position.start.transform[5], end: position.end.transform[5] }, frameConfig, bezierConfig);
      const colorR = MathUtil2.cubicBezier({ start: position.start.color.r ?? 0, end: position.end.color.r ?? 0 }, frameConfig, bezierConfig);
      const colorG = MathUtil2.cubicBezier({ start: position.start.color.g ?? 0, end: position.end.color.g ?? 0 }, frameConfig, bezierConfig);
      const colorB = MathUtil2.cubicBezier({ start: position.start.color.b ?? 0, end: position.end.color.b ?? 0 }, frameConfig, bezierConfig);
      const colorA = MathUtil2.cubicBezier({ start: position.start.color.a ?? 255, end: position.end.color.a ?? 255 }, frameConfig, bezierConfig);
      const objs = x.map((x2, idx) => {
        const obj = new Obj({ x: x2, y: y[idx], z: z[idx] });
        obj.volume = v[idx];
        obj.mass = m[idx];
        obj.e = e[idx];
        obj.rotate = r[idx];
        obj.width = w[idx];
        obj.height = h[idx];
        obj.transform = [t0[idx], t1[idx], t2[idx], t3[idx], t4[idx], t5[idx]];
        obj.color = { r: colorR[idx], g: colorG[idx], b: colorB[idx], a: colorA[idx] };
        return obj;
      });
      return objs;
    } else if (position.start instanceof Point3D && position.end instanceof Point3D) {
      const x = MathUtil2.cubicBezier({ start: position.start.x, end: position.end.x }, frameConfig, bezierConfig);
      const y = MathUtil2.cubicBezier({ start: position.start.y, end: position.end.y }, frameConfig, bezierConfig);
      const z = MathUtil2.cubicBezier({ start: position.start.z, end: position.end.z }, frameConfig, bezierConfig);
      return x.map((x2, idx) => new Point3D(x2, y[idx], z[idx]));
    }
    const { start, end } = position;
    const { frame } = frameConfig;
    let { p1x, p1y, p2x, p2y } = Array.isArray(bezierConfig) ? { p1x: bezierConfig[0], p1y: bezierConfig[1], p2x: bezierConfig[2], p2y: bezierConfig[3] } : bezierConfig;
    p1x = p1x === "random" ? Math.random() : p1x;
    p1y = p1y === "random" ? Math.random() : p1y;
    p2x = p2x === "random" ? Math.random() : p2x;
    p2y = p2y === "random" ? Math.random() : p2y;
    const result = [];
    const totalChange = end - start;
    const bezier2 = (t) => {
      const t2 = Number(t * t);
      const t3 = Number(t2 * t);
      const mt = Number(1 - t);
      const mt2 = Number(mt * mt);
      const mt3 = Number(mt2 * mt);
      return mt3 * 0 + 3 * mt2 * t * Number(p1y) + 3 * mt * t2 * Number(p2y) + t3 * 1;
    };
    const targetFrame = frame + 1;
    for (let i = 1; i < targetFrame; i++) {
      const t = i / targetFrame;
      const progress = bezier2(t);
      const value = start + totalChange * progress;
      result.push(value);
    }
    return result;
  }
  MathUtil2.cubicBezier = cubicBezier;
  MathUtil2.diff = (a, b) => {
    return Math.abs(a - b);
  };
  MathUtil2.distSqToLineSegment = (p, v, w) => {
    const l2 = (v.x - w.x) ** 2 + (v.y - w.y) ** 2;
    if (l2 === 0) return (p.x - v.x) ** 2 + (p.y - v.y) ** 2;
    let t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
    t = Math.max(0, Math.min(1, t));
    const projection = { x: v.x + t * (w.x - v.x), y: v.y + t * (w.y - v.y) };
    return (p.x - projection.x) ** 2 + (p.y - projection.y) ** 2;
  };
  MathUtil2.rotatePoint = (point, center, angleInRadians) => {
    const translatedX = point.x - center.x;
    const translatedY = point.y - center.y;
    const rotatedX = translatedX * Math.cos(angleInRadians) - translatedY * Math.sin(angleInRadians);
    const rotatedY = translatedX * Math.sin(angleInRadians) + translatedY * Math.cos(angleInRadians);
    return new Point2D(rotatedX + center.x, rotatedY + center.y);
  };
  MathUtil2.quadraticBezier = (p0, p1, p2, t) => {
    const mt = 1 - t;
    return mt * mt * p0 + 2 * mt * t * p1 + t * t * p2;
  };
})(MathUtil || (MathUtil = {}));
export {
  MathUtil
};
//# sourceMappingURL=MathUtil.js.map
